module.exports = __webpack_public_path__ + "static/media/icon-photo.7232c30d.svg";